const AudioList=[
  {
    num: 1,
    zi: 'i:',
    index: 0,
    word: 'bean',
    image: 'https://r.bjwxjs.com/EnAudio/1.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_201(1).mp3',
    isPlay: false,
  },
  {
    num: 1,
    zi: 'iː',
    index: 0,
    word: 'bean',
    image: 'https://r.bjwxjs.com/EnAudio/1.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_201(1).mp3',
    isPlay: false,
  },
  
  {
    num: 2,
    zi: 'ɪ',
    word: 'tip',
    index: 1,
    image: 'https://r.bjwxjs.com/EnAudio/2.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_202(1).mp3',
    isPlay: false,
  },
  {
    num: 2,
    zi: 'i',
    word: 'tip',
    index: 1,
    image: 'https://r.bjwxjs.com/EnAudio/2.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_202(1).mp3',
    isPlay: false,
  },
  {
    num: 3,
    zi: 'e',
    word: 'met',
    index: 2,
    image: 'https://r.bjwxjs.com/EnAudio/3.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_203(1).mp3',
    isPlay: false,
  },
  {
    num: 4,
    zi: 'æ',
    word: 'pan',
    isPlay: false,
    index: 3,
    image: 'https://r.bjwxjs.com/EnAudio/5.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_205(1).mp3'
  },
  {
    num: 5,
    zi: 'uː',
    word: 'moon',
    isPlay: false,
    index: 4,
    image: 'https://r.bjwxjs.com/EnAudio/6.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_206(1).mp3'
  },
  {
    num: 6,
    zi: 'ə',
    word: 'the',
    isPlay: false,
    index: 5,
    image: 'https://r.bjwxjs.com/EnAudio/7.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_207(1).mp3'
  },
  {
    num: 7,
    zi: 'ɜː',
    word: 'sir',
    isPlay: false,
    index: 6,
    image: 'https://r.bjwxjs.com/EnAudio/8.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_208(1).mp3'
  },
  {
    num: 8,
    zi: 'ʌ',
    word: 'fun',
    isPlay: false,
    index: 7,
    image: 'https://r.bjwxjs.com/EnAudio/9.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_209(1).mp3'
  },
  {
    num: 9,
    zi: 'ɑː',
    word: 'card',
    isPlay: false,
    index: 8,
    image: 'https://r.bjwxjs.com/EnAudio/10.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2010(1).mp3'
  },
  {
    num: 10,
    zi: 'ʊ',
    word: 'shook',
    isPlay: false,
    index: 9,
    image: 'https://r.bjwxjs.com/EnAudio/11.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2011(1).mp3'
  },
  {
    num: 11,
    zi: 'ɔː',
    word: 'shore',
    isPlay: false,
    index: 10,
    image: 'https://r.bjwxjs.com/EnAudio/12.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2012(1).mp3'
  },
  {
    num: 12,
    zi: 'ɒ',
    word: 'lock',
    isPlay: false,
    index: 11,
    image: 'https://r.bjwxjs.com/EnAudio/13.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2013(1).mp3'
  },
  {
    num: 13,
    zi: 'ɪə',
    index: 0,
    word: 'dear',
    image: 'https://r.bjwxjs.com/EnAudio/14.gif',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2014(1).mp3',
    isPlay: false,
  },
  {
    num: 14,
    zi: 'eɪ',
    word: 'same',
    index: 1,
    image: 'https://r.bjwxjs.com/EnAudio/15.gif',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2015(1).mp3',
    isPlay: false,
  },
  {
    num: 15,
    zi: 'aʊ',
    word: 'loud',
    index: 2,
    image: 'https://r.bjwxjs.com/EnAudio/16.gif',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2016(1).mp3',
    isPlay: false,
  },
  {
    num: 16,
    zi: 'əʊ',
    word: 'go',
    index: 3,
    isPlay: false,
    image: 'https://r.bjwxjs.com/EnAudio/17.gif',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2017(1).mp3'
  },
  {
    num: 17,
    zi: 'aɪ',
    word: 'hide',
    index: 4,
    isPlay: false,
    image: 'https://r.bjwxjs.com/EnAudio/18.gif',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2018(1).mp3'
  },
  {
    num: 18,
    zi: 'ɔɪ',
    word: 'choice',
    index: 5,
    isPlay: false,
    image: 'https://r.bjwxjs.com/EnAudio/19.gif',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2019(1).mp3'
  },
  {
    num: 19,
    zi: 'ʊə',
    index: 6,
    word: 'curious',
    isPlay: false,
    image: 'https://r.bjwxjs.com/EnAudio/20.gif',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2020(1).mp3'
  },
  {
    num: 20,
    zi: 'ɛː/eə',
    word: 'hair',
    index: 7,
    isPlay: false,
    image: 'https://r.bjwxjs.com/EnAudio/4.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_204(1).mp3'
  },
  {
    num: 21,
    zi: 'f',
    index: 0,
    word: 'first',
    image: 'https://r.bjwxjs.com/EnAudio/21.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2021(1).mp3',
    isPlay: false,
  },
  {
    num: 22,
    zi: 'v',
    word: 'van',
    index: 1,
    image: 'https://r.bjwxjs.com/EnAudio/22.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2022(1).mp3',
    isPlay: false,
  },
  {
    num: 23,
    zi: 'θ',
    word: 'thick',
    index: 2,
    image: 'https://r.bjwxjs.com/EnAudio/23.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2023(1).mp3',
    isPlay: false,
  },
  {
    num: 24,
    zi: 'ð',
    word: 'these',
    index: 3,
    isPlay: false,
    image: 'https://r.bjwxjs.com/EnAudio/24.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2024(1).mp3'
  },
  {
    num: 25,
    zi: 's',
    word: 'saw',
    index: 4,
    isPlay: false,
    image: 'https://r.bjwxjs.com/EnAudio/25.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2025(1).mp3'
  },
  {
    num: 26,
    zi: 'z',
    word: 'zen',
    index: 5,
    isPlay: false,
    image: 'https://r.bjwxjs.com/EnAudio/26.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2026(1).mp3'
  },
  {
    num: 27,
    zi: 'ʃ',
    index: 6,
    word: 'she',
    isPlay: false,
    image: 'https://r.bjwxjs.com/EnAudio/27.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2027(1).mp3'
  },
  {
    num: 28,
    zi: 'ʒ',
    index: 7,
    word: 'casual',
    isPlay: false,
    image: 'https://r.bjwxjs.com/EnAudio/28.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2028(1).mp3'
  },
  {
    num: 29,
    zi: 'h',
    index: 8,
    word: 'hard',
    isPlay: false,
    image: 'https://r.bjwxjs.com/EnAudio/29.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2029(1).mp3'
  },
  {
    num: 30,
    zi: 'p',
    index: 0,
    word: 'pick',
    image: 'https://r.bjwxjs.com/EnAudio/30.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2030(1).mp3',
    isPlay: false,
  },
  {
    num: 31,
    zi: 'b',
    word: 'bed',
    index: 1,
    image: 'https://r.bjwxjs.com/EnAudio/31.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2031(1).mp3',
    isPlay: false,
  },
  {
    num: 32,
    zi: 't',
    word: 'team',
    index: 2,
    image: 'https://r.bjwxjs.com/EnAudio/32.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2032(1).mp3',
    isPlay: false,
  },
  {
    num: 33,
    zi: 'd',
    word: 'dine',
    index: 3,
    isPlay: false,
    image: 'https://r.bjwxjs.com/EnAudio/33.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2033(1).mp3'
  },
  {
    num: 34,
    zi: 'k',
    word: 'code',
    index: 4,
    isPlay: false,
    image: 'https://r.bjwxjs.com/EnAudio/34.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2034(1).mp3'
  },
  {
    num: 35,
    zi: 'ɡ',
    word: 'get',
    index: 5,
    isPlay: false,
    image: 'https://r.bjwxjs.com/EnAudio/35.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2035(1).mp3'
  },
  {
    num: 36,
    zi: 'tʃ',
    index: 0,
    word: 'choose',
    image: 'https://r.bjwxjs.com/EnAudio/36.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2036(1).mp3',
    isPlay: false,
  },
  {
    num: 37,
    zi: 'dʒ',
    word: 'jet',
    index: 1,
    image: 'https://r.bjwxjs.com/EnAudio/37.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2037(1).mp3',
    isPlay: false,
  },
  {
    num: 38,
    zi: 'w',
    index: 0,
    word: 'watch',
    image: 'https://r.bjwxjs.com/EnAudio/38.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2038(1).mp3',
    isPlay: false,
  },
  {
    num: 39,
    zi: 'r',
    word: 'rug',
    index: 1,
    image: 'https://r.bjwxjs.com/EnAudio/39.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2039(1).mp3',
    isPlay: false,
  },
  {
    num: 40,
    zi: 'j',
    word: 'yet',
    index: 2,
    image: 'https://r.bjwxjs.com/EnAudio/40.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2040(1).mp3',
    isPlay: false,
  },
  {
    num: 41,
    zi: 'l',
    index: 0,
    word: 'look',
    image: 'https://r.bjwxjs.com/EnAudio/41.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2041(1).mp3',
    isPlay: false,
  },
  {
    num: 42,
    zi: 'm',
    index: 0,
    word: 'mode',
    image: 'https://r.bjwxjs.com/EnAudio/42.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2042(1).mp3',
    isPlay: false,
  },
  {
    num: 43,
    zi: 'n',
    word: 'neck',
    index: 1,
    image: 'https://r.bjwxjs.com/EnAudio/43.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2043(1).mp3',
    isPlay: false,
  },
  {
    num: 44,
    zi: 'ŋ',
    word: 'song',
    index: 2,
    image: 'https://r.bjwxjs.com/EnAudio/44.png',
    audio: 'https://r.bjwxjs.com/EnAudio/sound_2044(1).mp3',
    isPlay: false,
  }
]




module.exports = {
  AudioList: AudioList,
  

}

